import React from "react";
import { Box, BoxProps } from "@material-ui/core";

export const ActivityTitle: React.FC<BoxProps> = ({ children, ...props }) => {
  return (
    <>
      {React.Children.map(children, (child, i) => {
        const key = React.isValidElement(child)
          ? child.key || undefined
          : undefined;
        const my = i > 0 ? 0.5 : undefined;
        return (
          <Box {...props} my={my} key={key}>
            {child}
          </Box>
        );
      })}
    </>
  );
};
